import { Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LoginIcon from '@mui/icons-material/Login';

function ToLoginButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const toLogin = () => {
    navigate('/login', { state: { next: `${location.pathname}${location.search}` } });
  };

  return (
    <Button onClick={toLogin} color="inherit" data-testid="loginButton" startIcon={<LoginIcon />}>
      {t('common.actions.login')}
    </Button>
  );
}

export default ToLoginButton;
